module.exports = __webpack_public_path__ + "static/energy_10-2540c2a4faabb121e554c10d449a176b.jpg";